import axios from 'axios';

export function fetchLawFirmDecisions(lawOfficeIds: Array<string>) {
  return axios.get('/getLawFirmDecisions', {
    params: {
      lawOfficeIds,
    },
  });
}

export function fetchLawyersByOffice(lawOfficeId: string, nic: string) {
  const params = {
    lawOfficeId,
    nic,
  };
  return axios.get('/findLawyersByOffice', { params });
}

export function fetchEnterprises(
  lawOfficeIdGroup: string,
  full: boolean = false,
) {
  return axios.get('/getLawFirmEnterprises', {
    params: {
      lawOfficeId: lawOfficeIdGroup,
      full,
    },
  });
}

export function fetchLawFirmCustomers(lawOfficeIdGroup: string) {
  return axios.get('/getLawFirmCustomers', {
    params: {
      lawOfficeId: lawOfficeIdGroup,
    },
  });
}

export function fetchLawFirmInfos(lawOfficeIdGroup: string) {
  return axios.get('/getLawFirmPopover', {
    params: {
      lawOfficeIdGroup,
    },
  });
}

export function fetchLawFirmKeywords(lawOfficeIdGroup: string) {
  return axios.get('/getLawFirmKeywords', {
    params: {
      lawOfficeIdGroup,
    },
  });
}

export function fetchLawFirmTopDecisions(lawOfficeIdGroup: string) {
  return axios.get('/getLawFirmTopDecisions', {
    params: {
      lawOfficeIdGroup,
    },
  });
}
